import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useActiveLang } from "../../../../domains/app/hooks/useActiveLang";
import { useChangeLanguage } from "../../../../domains/app/hooks/useChangeLanguage";
import {
  LANGUAGE_LABELS,
  LANGUAGE_ORDER,
} from "../../../../components/settings/sheet/views/LanguageView";
import {
  SettingsOptionRow,
  SettingsPage,
  SettingsSection,
} from "../components/SettingsPanel";

/**
 * Language (Figma "D3.settings.language"): each language by its English name
 * over its endonym, the one in use checked, applied at the click.
 */
export function LanguageSection(): React.JSX.Element {
  const { t } = useTranslation();
  const { activeLang } = useActiveLang();
  const changeLanguage = useChangeLanguage();
  // useForm only for an in-flight flag: a second pick waits for the first.
  const { handleSubmit, formState } = useForm();

  return (
    <SettingsPage back={null}>
      <SettingsSection title={t("Language")} description={null}>
        <div className="flex flex-col gap-0.5 pt-1.5">
          {LANGUAGE_ORDER.map((lang) => (
            <SettingsOptionRow
              key={lang}
              lines={2}
              selected={lang === activeLang}
              disabled={formState.isSubmitting}
              onSelect={() => {
                void handleSubmit(() => changeLanguage(lang))();
              }}
            >
              <span
                className={
                  lang === activeLang
                    ? "text-sm font-semibold text-ds-slate-950"
                    : "text-sm font-medium text-ds-slate-950"
                }
              >
                {LANGUAGE_LABELS[lang].name}
              </span>
              <span className="text-desktop-meta text-ds-slate-700">
                {LANGUAGE_LABELS[lang].native}
              </span>
            </SettingsOptionRow>
          ))}
        </div>
      </SettingsSection>
      <p className="m-0 text-desktop-meta text-ds-slate-700">
        {t(
          "The app language will change. Scientific content stays in its original language."
        )}
      </p>
    </SettingsPage>
  );
}
